// Sample workflows for demonstration
export const SAMPLE_WORKFLOWS = [
  {
    id: 'wf-001',
    displayName: 'Supplier Invoice Processing',
    description: 'Automatically extract invoice data, validate against POs, and post to Epicor',
    status: 'published',
    steps: 4,
    connectors: ['Epicor ERP', 'Email', 'Database'],
    executions: 234,
    lastRun: '2 hours ago',
  },
  {
    id: 'wf-002',
    displayName: 'Purchase Order Auto-Approval',
    description: 'Route POs based on amount, department, and approver availability',
    status: 'published',
    steps: 5,
    connectors: ['Epicor ERP', 'Email', 'Slack'],
    executions: 156,
    lastRun: '30 minutes ago',
  },
  {
    id: 'wf-003',
    displayName: 'Shopify Order Sync',
    description: 'Sync Shopify orders to Epicor SO, update inventory in real-time',
    status: 'published',
    steps: 6,
    connectors: ['Epicor ERP', 'Shopify', 'Database'],
    executions: 89,
    lastRun: '5 minutes ago',
  },
  {
    id: 'wf-004',
    displayName: 'Customer Order Notification',
    description: 'Send order confirmation, shipping, and delivery updates via email and SMS',
    status: 'draft',
    steps: 3,
    connectors: ['Email', 'Slack'],
    executions: 0,
    lastRun: 'Never',
  },
];

export const SAMPLE_EXECUTIONS = [
  {
    id: 'exec-001',
    workflowName: 'Supplier Invoice Processing',
    status: 'success',
    startedAt: '2026-06-02T14:32:00Z',
    duration: '45s',
    steps: 4,
    errors: 0,
  },
  {
    id: 'exec-002',
    workflowName: 'Purchase Order Auto-Approval',
    status: 'success',
    startedAt: '2026-06-02T14:28:00Z',
    duration: '12s',
    steps: 5,
    errors: 0,
  },
  {
    id: 'exec-003',
    workflowName: 'Shopify Order Sync',
    status: 'success',
    startedAt: '2026-06-02T14:25:00Z',
    duration: '8s',
    steps: 6,
    errors: 0,
  },
  {
    id: 'exec-004',
    workflowName: 'Supplier Invoice Processing',
    status: 'failed',
    startedAt: '2026-06-02T13:45:00Z',
    duration: '23s',
    steps: 3,
    errors: 1,
  },
];
